import {useEffect} from 'react'
import "./Aboutus.css";
import 'aos/dist/aos.css';
import AOS from 'aos';
const Aboutus = () => {
  useEffect(() => {
    AOS.init();
  }, [])
  return (
    <>
    <div class="container-xxl">
        <div class="row">
        <div class="d-ff">
                    <div class="w-100"  data-aos="zoom-in-down" >
                    <h4 className='mb-4 textsix'>Why Only Quaid Soft as Trusted Software Development & IT Company?</h4>
                        <p class="abutextjus">Quaid Soft® is entirely a registered software development firm from the Govt. of Pakistan as well
                             as under the firm registration law “Rule 9 (A) Section 58 (1) 1932." Quaid Soft was properly registered as a software
                              and IT company in 2015. Quaid Soft is purely a real estate software automation company. Where It’s Management 
                              (Mian Azhar and Muhammad Mustafa) having 15 years + experience in real estate automation Quaid Soft is serving approximately 600+
                               real estate housing and high-rise building projects in all provinces of Pakistan. We are providing all kinds of software,
                                web and mobile applications, as well as hardware, network sales and maintenance services. Our aim is to provide our customers
                                 with the best-quality products and believe in after sale services in Pakistan and the Middle East. Quaid Soft is always dedicated 
                                 and a specialist in delivering the solution to builders and developers for their housing and commercial projects. Our service domain 
                                 sectors are real estate, builders, developers, construction companies, marketing companies, trading sectors, inventory sectors, (POS)
                                  point of sale, hotels, restaurants, pharmaceuticals, factories, marts, boutiques, production firms, and guest house setups.</p>
                        </div>                  
                   <div className='w-80' data-aos="zoom-in"  >
                     <img class="aboutimg" src={process.env.PUBLIC_URL +'/Images/Aboutus/about-jif.gif'} alt="quaidsoft-about us"/>
                       </div>                          
                       </div>
                       </div>
                       </div>
               
    </>
  );
}

export default Aboutus;